<template>
  <div
    id="gamified-offers-banner"
    class="margin-top-s margin-bottom-s"
  >
    <BannerImage :banner-details="store.gamifiedOffer[0].offerRecords[0]" />
    <div class="grid-x padding-top-m padding-left-s padding-right-s">
      <OfferDetails />
      <Categories v-if="store.showCategories" />
    </div>
    <div class="grid-x padding-left-s padding-right-s padding-bottom-s">
      <CategoriesTracker />
    </div>
  </div>
</template>

<script setup>
import { watch } from 'vue';
import BannerImage from '@nuxt-common/gamified-offers-banner/app/components/BannerImage.vue';
import OfferDetails from '@nuxt-common/gamified-offers-banner/app/components/OfferDetails.vue';
import Categories from '@nuxt-common/gamified-offers-banner/app/components/Categories/index.vue';
import CategoriesTracker from '@nuxt-common/gamified-offers-banner/app/components/Categories/CategoriesTracker.vue';
import { useGamifiedOfferStore } from '@nuxt-common/gamified-offers-banner/app/stores/gamifiedOffer';

const props = defineProps({
  offers: {
    type: String,
    default: '',
  },
  username: {
    type: String,
    default: '',
  },
});

const store = useGamifiedOfferStore();

store.initialize(props.offers, props.username);

watch(
  () => props.offers,
  (newOffers) => {
    store.rawOffers = newOffers;
  },
);
watch(
  () => props.username,
  (newUsername) => {
    store.username = newUsername;
  },
);
</script>
